import { render, staticRenderFns } from "./WithdrawConfirmModal.vue?vue&type=template&id=cf04555a&scoped=true&"
import script from "./WithdrawConfirmModal.vue?vue&type=script&lang=js&"
export * from "./WithdrawConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawConfirmModal.vue?vue&type=style&index=0&id=cf04555a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf04555a",
  null
  
)

export default component.exports